import React from 'react';
import { FieldProps } from '@rjsf/core';
import { useSelectCountryLang } from './hooks/useSelectCountryLang';
import { Autocomplete, FormControl, MenuItem, TextField } from '@mui/material';
import { CountryLangPropType } from './hooks/useGetCountryLanguage';
import { useTranslations } from 'hooks';

export const SelectCountryLanguage: React.FC<FieldProps> = (props: FieldProps<CountryLangPropType | undefined>) => {

    const {
        value,
        countryOptions,
        languageOptions,
        handleChangeCountry,
        handleChangeLanguage
    } = useSelectCountryLang(props)

    const [
        COUNTRY,
        LANG
    ] = useTranslations(i18n)
    
    return (
        <div className="select-country-language">
            <FormControl id="commonCountrySelectCountryLanguage" className={`control-select-language ${props.className}`}>
                <Autocomplete
                    options={countryOptions || []}
                    autoHighlight
                    value={value?.country || null}
                    getOptionLabel={(option) => option.name}
                    onChange={handleChangeCountry}
                    loading={countryOptions?.length === 0}
                    renderOption={(props, option) => (
                        <MenuItem value={option.code} {...props}>
                            { renderFlag(option.code) } {option.name}
                        </MenuItem>
                    )}
                    renderInput={(params) => {
                        const option = countryOptions?.find((item) => item.name === (params.inputProps as Record<string, unknown>).value as string)
                        return (
                            <div className="control-select-language-selected">
                                { option && renderFlag(option.code) }
                                <TextField
                                    {...params}
                                    label={`${COUNTRY} ${props.required ? '*' : ''}`}
                                    inputProps={{
                                        ...params.inputProps as any,
                                        autoComplete: 'off',
                                    }}
                                    />
                            </div>
                        )
                    }}
                    />
            </FormControl>
            <FormControl id="commonLanguageSelectCountryLanguage" className={`control-select-language ${props.className}`}>
                <Autocomplete
                    options={languageOptions || []}
                    autoHighlight
                    value={value?.language || null}
                    getOptionLabel={(option) => option.name}
                    onChange={handleChangeLanguage}
                    loading={languageOptions?.length === 0}
                    renderOption={(props, option) => (
                        <MenuItem value={option.code} {...props}>
                            { renderFlag(option.code, 'LANGUAGE')} {option.name}
                        </MenuItem>
                    )}
                    renderInput={(params) => {
                        const option = languageOptions?.find((item) => item.name === (params.inputProps as Record<string, unknown>).value as string)
                        return (
                            <div className="control-select-language-selected">
                                { option && renderFlag(option.code, 'LANGUAGE') }
                                <TextField
                                    {...params}
                                    label={`${LANG} ${props.required ? '*' : ''}`}
                                    inputProps={{
                                        ...params.inputProps as any,
                                        autoComplete: 'off',
                                    }}
                                    />
                            </div>
                        )
                    }}
                />
            </FormControl>
        </div>
    )
}

const i18n = [
    'SDS1Click.Common.Country.label',
    'SDS1Click.Common.Language.label'
]

/**
     * TODOC
     * @param code country/language code
     * @param format 24x24 / 48x48 
     */
export const renderFlag = (code: string, type?: FlagType, format?: string ) => {
    let countryCode = code;
    if(type == 'LANGUAGE') {
        switch (code.toUpperCase()) {
            case 'EN':
                countryCode = 'GB'
                break;
            case 'JA':
                countryCode = 'JP'
                break;
            case 'ZH':
                countryCode = 'CN'
                break;
            case 'CS':
                countryCode = 'CZ'
                break;
            case 'DA':
                countryCode = 'DK'
                    break;
            case 'EL':
                countryCode = 'GR'
                    break;
            case 'LB':
                countryCode = 'LU'
                break;
            case 'TA':
                countryCode = 'IN'
                break;
            case 'ZF':
                countryCode = 'CN'
                break;
            case 'KO':
                countryCode = 'KR'
                break;
            default:
                countryCode = code
                break;
        }
    }
    return (
        <img 
        className="float-left mr-10"
        src={`/assets/img/flag/${format ? format :'24x24'}/${countryCode}.png`} 
        alt={countryCode} />
    )
}

type FlagType = 'COUNTRY' | 'LANGUAGE'
